// extracted by mini-css-extract-plugin
export default {"timeline-wrapper":"Timeline_timeline-wrapper__Pj21m","year-selector":"Timeline_year-selector__Gvon3","timeline":"Timeline_timeline__vbIC5"};